<template>
  <div>
    <!-- //头部 -->
    <div class="nav">
      <div class="all_box">
        <div class="nav_box">
          <div class="nav_logo">
            <img src="@/assets/img/head_logo.png" @click="tabClick('Home')">
          </div>
          <div class="nav_list">
            <ul>
              <li @click="tabClick('Home')" :class="$route.name == 'Home'?'nav_on':'nav_off'">主页</li>
              <li @click="tabClick('About')" :class="$route.name == 'About'?'nav_on':'nav_off'">关于我们</li>
              <li @click="tabClick('Serve')" :class="$route.name == 'Serve'?'nav_on':'nav_off'">企业服务</li>
              <li @click="tabClick('Programme')" :class="$route.name == 'Programme'?'nav_on':'nav_off'">社保方案</li>
              <li @click="tabClick('NewList')" :class="$route.name == 'NewList'||$route.name == 'NewDetail'?'nav_on':'nav_off'">新闻动态</li>
              <li @click="tabClick('Contact')" :class="$route.name == 'Contact'?'nav_on':'nav_off'">联系方式</li>
            </ul>
          </div>
          <div class="nav_phone">
            <img src="@/assets/img/title_phone.png">
            0573-87763210
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navs',
    props: {
      msg: String
    },
    methods: {
      tabClick(item) {
        this.$router.push({
          name: item
        });
      },
    },
  }
</script>
<style lang="scss" scoped>
  .nav_logo{
    cursor: pointer;
  }
  .nav {
    margin-bottom: 36px;
    margin-top: 36px;
  }

  .nav_on {
    border-bottom: 1px solid #f08300 !important;
    color: #F08300;
  }

  .nav_list {
    padding-top: 18px;

    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        cursor: pointer;
        margin: 0 32px;
        border-bottom: 1px dashed #000;
        padding-bottom: 8.5px;
      }

      li:first-child {
        margin-left: 0;
      }

      li:last-child {
        margin-right: 0;
      }
    }
  }

  .nav_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .nav_phone {
    box-sizing: border-box;
    padding: 14px 18px;
    height: 44px;
    border: 1px solid #cbcbcb;
    border-radius: 10px;
    margin-top: 10px;

    img {
      margin-right: 12px;
      display: inline-block;
    }
  }
</style>